import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectInDisplayContent } from '../../features/displayContent/selectors'
import { CrystallineContent } from '../../model/model'
import {
	FirstLine,
	ImagesBox,
	SecondLine,
	ThirdLine,
	TitleWrapper,
	Wrapper,
} from './CommonComponents'
import MediaBox from './MediaBox'

const isCrystallineLensContent = (
	content?: any,
): content is CrystallineContent => content?.section === 'crystallineLens'

export const CrystallineLens: React.FC = () => {
	const { t } = useTranslation()
	const displayContent = useSelector(selectInDisplayContent)

	const data = displayContent?.data
	return (
		<Wrapper>
			<TitleWrapper>
				<FirstLine>{t('content.clinicalData')}</FirstLine>
				<SecondLine>{t('content.crystallineLens')}</SecondLine>
				<ThirdLine>{t('content.crystallineLensInfo')}</ThirdLine>
			</TitleWrapper>
			{isCrystallineLensContent(data) && (
				<ImagesBox className="vertical">
					<MediaBox media={data.content.OD} />
					<MediaBox media={data.content.OS} />
				</ImagesBox>
			)}
		</Wrapper>
	)
}

export default CrystallineLens
